import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import Dropzone from 'react-dropzone';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

import CustomReveal from '../../common/reveal/CustomReveal';
import CustomIcon from '../../common/CustomIcon';

import * as classroomActions from '../../../actions/classroom/classroomActions';
import * as componentsActions from '../../../actions/componentActions';
import { SmartButton } from '../../common/SmartButton';

const styles = {
  linkExample: {
    color: props => props.colors.btnText,
    '&:hover': {
      color: props => props.colors.btnTextHover
    }
  },
  browseButton: {
    backgroundColor: props => props.colors.btnSuccess,
    '&:hover': {
      backgroundColor: props => props.colors.btnSuccessHover
    }
  }
};

class ImportStudentsReveal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeImportCSVModal = this.closeImportCSVModal.bind(this);
    this.closeImportCSVModal = this.closeImportCSVModal.bind(this);
    this.deleteCSVFile = this.deleteCSVFile.bind(this);
    this.importCSVFile = this.importCSVFile.bind(this);
  }

  static propTypes = {
    active: PropTypes.bool
  };

  closeImportCSVModal() {
    const { classroomActions, csvFile } = this.props;

    if (csvFile) this.deleteCSVFile();

    classroomActions.setImportCSVModalState(false);
  }

  onDrop(acceptedFiles) {
    const { classroomActions } = this.props;
    classroomActions.saveCSVFile(acceptedFiles[0]);
  }

  importCSVFile() {
    const { classroomActions, csvFile, classroom, componentsActions } = this.props;
    classroomActions.setImportCSVModalState(false);

    componentsActions.setActiveLoaderState(true);

    classroomActions.getStudentsImportedFromCSV(csvFile, classroom.sectionId, classroom.id).then(() => {
      componentsActions.setActiveLoaderState(false);
    });
  }

  deleteCSVFile() {
    const { classroomActions } = this.props;
    classroomActions.saveCSVFile(null);
  }

  renderDropContainerFile() {
    const { csvIcon, csvFile, classes } = this.props;

    return (
      <div>
        <img alt="" src={csvIcon} />
        <div className="file-name">{csvFile.name}</div>
        <div className="file-buttons">
          <button type="button" className={`${classes.linkExample}`}>
            {I18n.t('importStudentsPopup.change')}
          </button>
          <span className="middle-dot">&middot;</span>
          <button type="button" onClick={this.deleteCSVFile} className={`${classes.linkExample}`}>
            {I18n.t('common.delete')}
          </button>
        </div>
      </div>
    );
  }

  renderDropContainerNoFile() {
    const { csvIcon, classes } = this.props;

    return (
      <div>
        <img alt="" src={csvIcon} />
        <div className="text">{I18n.t('importStudentsPopup.text')}</div>
        <button type="button" className={`button browse-button ${classes.browseButton}`}>
          {I18n.t('importStudentsPopup.browse')}
        </button>
      </div>
    );
  }

  renderDropZone() {
    const { csvFile } = this.props;

    if (csvFile) {
      return this.renderDropContainerFile();
    }
    return this.renderDropContainerNoFile();
  }

  render() {
    const { active, csvFile, classes } = this.props;
    let disabledImportBtn = true;
    let disableClick = false;

    if (csvFile) {
      disabledImportBtn = false;
      disableClick = false; //TODO
    }

    return (
      <CustomReveal id="import-csv" active={active} close={this.closeImportCSVModal}>
        <div className="reveal-import-csv">
          <div className="header">
            <span className="close-btn" onClick={this.closeImportCSVModal}>
              <CustomIcon name="close-button" size={24} />
            </span>
            <span className="title">{I18n.t('importStudentsPopup.title')}</span>
          </div>

          <div className="content">
            <div>
              <div className="drop-container">
                <Dropzone
                  multiple={false}
                  accept={'.csv'}
                  disableClick={disableClick}
                  disablePreview={false}
                  onDrop={files => this.onDrop(files)}
                  style={{ width: '100%' }}
                >
                  {this.renderDropZone()}
                </Dropzone>
                <a
                  download="students.csv"
                  href="/sample_files/students.csv"
                  className={`example-link ${classes.linkExample}`}
                >
                  {I18n.t('importStudentsPopup.exampleLink')}
                </a>
              </div>
            </div>
            <div className="confirm-buttons">
              <SmartButton onClick={this.closeImportCSVModal}>{I18n.t('common.cancel')}</SmartButton>
              <SmartButton onClick={this.importCSVFile} success disabled={disabledImportBtn}>
                {I18n.t('importStudentsPopup.importCSV')}
              </SmartButton>
            </div>
          </div>
        </div>
      </CustomReveal>
    );
  }
}

function mapStateToProps(state) {
  return {
    classroom: state.classrooms.selectedClassroom.classroom,
    active: state.classrooms.importCSVModalIsOpen,
    csvFile: state.classrooms.csvFile,
    i18n: state.i18n,
    colors: state.theme.colors,
    csvIcon: state.theme.images.placeholders.csvIcon
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    componentsActions: bindActionCreators(componentsActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(injectSheet(styles)(ImportStudentsReveal));
